export default __webpack_public_path__ + "static/bg_ambslot-88058d6497dd80082877dce8f46bd3d4.png";